import { useCallback } from 'react';
import { TeamSearchItem } from 'TeamModule/api/searchTeamsByFieldsApi';
import { TeamsV2ListItem } from './types';

export const ROW_TYPES = {
  HEADER: 'HEADER',
  DATA: 'DATA',
  DETAILS: 'DETAILS',
} as const;

export const useTeamsV2ListItemBuilder = () => {
  const builder = useCallback(
    ({ teams, expandedIds }: { teams: TeamSearchItem[]; expandedIds: Set<string> }) => {
      const header: TeamsV2ListItem = {
        id: ROW_TYPES.HEADER,
        rowType: ROW_TYPES.HEADER,
        isStickyHeader: true,
      };

      const dataRows: TeamsV2ListItem[] = teams.map((team) => ({
        id: team.id,
        rowType: ROW_TYPES.DATA,
        team,
        listItems: [
          {
            id: `${team.id}-details`,
            rowType: ROW_TYPES.DETAILS,
            team,
            collapseProps: {
              shouldWrapWithCollapse: true,
              isCollapse: expandedIds.has(team.id),
            },
            isFullWidthRow: true,
          },
        ],
      }));

      return [header, ...dataRows];
    },
    [],
  );

  return builder;
};

export default useTeamsV2ListItemBuilder;
